module.exports = __webpack_public_path__ + "static/media/download.c41e08cf.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/ftyc/img/download.png
 ** module id = 1461
 ** module chunks = 0
 **/